export const encodeQueryParams = (params?: Record<string, string>): string => {
  if (!params || Object.keys(params).length === 0) {
    return "";
  }
  return `?${new URLSearchParams(params).toString()}`;
};
